// extracted by mini-css-extract-plugin
export default {"row_wrapper":"ProjectProtocolsTableEmptyRow_row_wrapper__jIJ73","row":"ProjectProtocolsTableEmptyRow_row__WrdDl"};